import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

export default function MenuAppBar() {
	const [auth, setAuth] = React.useState(true);
	const [anchorAppMenu, setAnchorAppMenu] = React.useState(null);
	const [anchorUserMenu, setAnchorUserMenu] = React.useState(null);
	const handleChange = (event) => {
		setAuth(event.target.checked);
	};

	const handleUserMenu = (event) => {
		setAnchorUserMenu(event.currentTarget);
	};

	const handleCloseUserMenu = () => {
		setAnchorUserMenu(null);
	};

	const handleAppMenu = (event) => {
		console.log(event.currentTarget);
		setAnchorAppMenu(event.currentTarget);
	};

	const handleCloseAppMenu = () => {
		setAnchorAppMenu(null);
	};

	return (
					<AppBar position="static">
						<Toolbar>
							<IconButton
								size="large"
								edge="start"
								sx={{mr: 2}}
								aria-label="app menu"
								aria-controls="menu"
								aria-haspopup="true"
								onClick={handleAppMenu}
								color="inherit"
								>
								<MenuIcon />
							</IconButton>
							<Menu
								id="menu"
								anchorEl={anchorAppMenu}
								anchorOrigin={{
										vertical: 'top',
										horizontal: 'right'
									}}
								keepMounted
								transformOrigin={{
										vertical: 'top',
										horizontal: 'left'
									}}
								open={Boolean(anchorAppMenu)}
								onClose={handleCloseAppMenu}
								>
								<MenuItem onClick={handleCloseAppMenu}>My Entries</MenuItem>
							</Menu>
							<Typography variant="h4" component="div" sx={{display: 'flex',flexGrow: 1,justifyContent:'center'}}>
								Inscriptions en ligne
							</Typography>
					
							{auth && (
											<div>
												<IconButton
													size="large"
													aria-label="account of current user"
													aria-controls="menu-appbar"
													aria-haspopup="true"
													onClick={handleUserMenu}
													color="inherit"
													>
													<AccountCircle />
												</IconButton>
												<Menu
													id="menu-appbar"
													anchorEl={anchorUserMenu}
													anchorOrigin={{
																					vertical: 'top',
																					horizontal: 'left',
																				}}
													keepMounted
													transformOrigin={{
																	vertical: 'top',
																	horizontal: 'right',
																}}
													open={Boolean(anchorUserMenu)}
													onClose={handleCloseUserMenu}
													>
													<MenuItem onClick={handleCloseUserMenu}>Profile</MenuItem>
													<MenuItem onClick={handleCloseUserMenu}>Disconnet</MenuItem>
												</Menu>
											</div>
												)}
						</Toolbar>
					</AppBar>
					);
}